/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ITumorBoardOccurrenceParticipant } from 'app/shared/model/tumor-board-occurrence-participant.model';
import { ITumorBoardOccurrence } from 'app/shared/model/tumor-board-occurrence.model';
import { ITumorBoardPatient } from 'app/shared/model/tumor-board-patient.model';
import { MemberRole } from 'app/shared/model/enumerations/member-role.model';

export interface ITumorBoardParticipantOutcome {
  id?: string;
  joinedAt?: number;
  leftAt?: number | null;
  memberId?: string | null;
  memberRole?: keyof typeof MemberRole | null;
  skipped?: boolean | null;
  opinionSummary?: string | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  boardMember?: ITumorBoardOccurrenceParticipant | null;
  occurrence?: ITumorBoardOccurrence | null;
  patient?: ITumorBoardPatient | null;
}

export const defaultValue: Readonly<ITumorBoardParticipantOutcome> = {
  skipped: false,
  active: false,
};
